import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import _ from 'lodash';
import { Container, Layout, GeoNZIPModalContainer } from "../../_global";
import { OFFER_TYPES } from "../../../constants/app";
import FAQs from "../../Faq/FAQs";
import ErrorPage from "../../../pages/_error";
import { clearShopMerchant } from "../../../reducers/shop";
import { toggleFavourite } from "../../../reducers/user";
import TrackingUtilities from "../../../utils/trackingUtilities";
import { MALL_STATUS } from "../../../utils/mallStatus";
import getFilteredFaqs from "../../../utils/getFilteredFaqs";
import MerchantPanel from "./MerchantPanel";
import query from "./query";
import { merchantProps, merchantPropsDefault } from "./merchantProps";
import MultipleCallout from "../Direct/MultipleCallout";
import { MerchantWrapper, MerchantCardContainer, MerchantMain, FAQWrapper, PointsCalloutHeadline } from "../Style/index";
import CookieWarning from "./CookieWarning";
import LoginConfirmation from "./LoginConfirmation";
import TrackingConfirmation from "./TrackingConfirmation";
import About from "../Components/About";
import CustomisedButton from "../Components/CustomisedButton";
import { buttonTypeLabel } from "../Enum/ButtonEnum";
import TopBanner from "../Components/Banner";
import OtherStoreSlider from "../Components/OtherStoreSlider";
import MerchantCoupon from "../Components/MerchantCoupon";
import ResponsiveLogo from "../Components/ResponsiveLogo";
import ImportantInfoFooter from "../Components/ImportantInfoFooter";
import OlmMerchantCard from "../Components/Cards/OlmMerchantCard";
import McoMerchantCard from "../Components/Cards/McoMerchantCard";
import DirectMerchantCard from "../Components/Cards/DirectMerchantCard";
var MerchantDetail = /*#__PURE__*/function (_Component) {
  function MerchantDetail(props) {
    var _this;
    _classCallCheck(this, MerchantDetail);
    _this = _callSuper(this, MerchantDetail, [props]);
    _this.toggleInfo = function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    };
    _this.state = {
      isExpanded: false
    };
    _this.cardContainerRef = /*#__PURE__*/React.createRef();
    _this.setCardContainerRef = function (element) {
      _this.cardContainerRef = element;
    };
    return _this;
  }
  _inherits(MerchantDetail, _Component);
  return _createClass(MerchantDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var merchant = this.props.merchant;
      TrackingUtilities.updatePageInfo({
        storeName: merchant.merchantName
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TrackingUtilities.updatePageInfo({
        storeName: null
      });
      this.props.clearShopMerchant();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        loading = _this$props.loading,
        error = _this$props.error,
        merchant = _this$props.merchant,
        bonusCampaignItems = _this$props.bonusCampaignItems,
        faqSections = _this$props.faqData.faqSections,
        ipAddress = _this$props.ipAddress;
      var bonusRibbons = _.get(bonusCampaignItems, ['0', 'bonusRibbons'], []);
      if (loading) {
        return __jsx(Container, null, "Loading");
      }
      if (merchant && !merchant.isVisible) {
        return __jsx(ErrorPage, {
          statusCode: 404
        });
      }
      var isEnabledMallOffer = MALL_STATUS.isActive(merchant.merchantStatus);
      if (error !== null && error !== void 0 && error.message) {
        if (error.message.includes("Cannot read property 'merchantName' of undefined")) {
          return __jsx(ErrorPage, {
            statusCode: 404
          });
        }
        return __jsx(Container, null, "Error");
      }
      if (merchant) {
        var _merchant$merchantPan;
        var metaTitle = merchant.metaTags || merchant.merchantName;
        var filteredFaq = getFilteredFaqs(merchant, faqSections);
        var tiles = _.get(merchant, 'tiles', []);
        var directTile = tiles.find(function (t) {
          return t.type === OFFER_TYPES.DIRECT;
        });
        var olmTile = tiles.find(function (t) {
          return t.type === OFFER_TYPES.MALL;
        });
        var showOlmPebble = olmTile === null || olmTile === void 0 ? void 0 : olmTile.showPebble;
        var numberOfMerchantCards = _.get(this.cardContainerRef, 'childElementCount', 0);
        return __jsx(Layout, {
          title: metaTitle,
          description: merchant.metaDescription,
          slug: merchant.merchantId,
          logo: merchant.merchantLogoSquare
        }, __jsx(CookieWarning, {
          merchantName: merchant.merchantName,
          merchantLogo: merchant.merchantLogoSquare
        }), __jsx(LoginConfirmation, {
          merchantId: merchant.merchantId,
          merchantIdOLM: merchant.merchantIdOLM
        }), __jsx(TrackingConfirmation, {
          merchants: merchant.similarMerchants
        }), __jsx(ResponsiveLogo, {
          merchant: merchant
        }), __jsx(MerchantWrapper, null, __jsx(TopBanner, {
          merchant: merchant
        }), __jsx(MerchantMain, {
          isGrey: true
        }, merchant.pointsCalloutHeadline && __jsx(PointsCalloutHeadline, null, merchant.pointsCalloutHeadline), ((_merchant$merchantPan = merchant.merchantPanel) === null || _merchant$merchantPan === void 0 ? void 0 : _merchant$merchantPan.title) && __jsx(MerchantPanel, {
          content: merchant.merchantPanel
        }), __jsx(MerchantCardContainer, {
          ref: this.setCardContainerRef,
          totalMerchantCards: numberOfMerchantCards,
          showPebble: tiles.some(function (_ref) {
            var showPebble = _ref.showPebble;
            return showPebble && showPebble !== null;
          })
        }, directTile && __jsx(DirectMerchantCard, {
          tile: directTile,
          slug: merchant.merchantId
        }), olmTile && __jsx(OlmMerchantCard, {
          tile: olmTile,
          bonusRibbons: bonusRibbons,
          showPebble: showOlmPebble,
          merchant: merchant,
          slug: merchant.merchantId
        }), merchant.merchantIdMCO && __jsx(McoMerchantCard, {
          merchant: merchant,
          slug: merchant.merchantId
        }))), __jsx(FAQWrapper, {
          wideView: true
        }, merchant.has_coupon && isEnabledMallOffer && __jsx(MerchantCoupon, {
          merchant: merchant
        })), merchant.calloutBlock.length > 0 && __jsx(MultipleCallout, {
          merchantCallouts: merchant.calloutBlock
        }), merchant.similarMerchants.length > 0 && __jsx(OtherStoreSlider, {
          merchant: merchant
        }), filteredFaq && filteredFaq.length > 0 && __jsx(FAQWrapper, {
          wideView: true
        }, __jsx("h2", null, "Frequently asked questions"), __jsx(FAQs, {
          faqSections: filteredFaq
        })), __jsx(About, {
          merchant: merchant
        }), __jsx(CustomisedButton, {
          type: buttonTypeLabel.scrollTotop.type
        })), merchant.merchantImportantInfo && __jsx(ImportantInfoFooter, {
          merchantImportantInfo: merchant.merchantImportantInfo
        }), merchant.merchantId === 'woolworths' && __jsx(GeoNZIPModalContainer, {
          ipAddress: ipAddress
        }));
      }
      return null;
    }
  }]);
}(Component);
MerchantDetail.defaultProps = merchantPropsDefault;
var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$user = _ref2.user,
    authenticated = _ref2$user.authenticated,
    authorized = _ref2$user.authorized,
    favourites = _ref2$user.favourites;
  return {
    authenticated: authenticated,
    authorized: authorized,
    favourites: favourites
  };
};
var mapDispatchToProps = {
  toggleFavourite: toggleFavourite,
  clearShopMerchant: clearShopMerchant
};
export default compose(connect(mapStateToProps, mapDispatchToProps), graphql(query.merchantQuery, {
  options: function options(ownProps) {
    return {
      variables: {
        merchantId: ownProps.slug
      }
    };
  },
  props: function props(_ref3) {
    var data = _ref3.data;
    return data;
  }
}), graphql(query.getFAQs, {
  props: function props(_ref4) {
    var data = _ref4.data;
    return {
      faqData: data
    };
  },
  options: function options() {
    return {
      fetchPolicy: 'cache-and-network',
      ssr: false
    };
  }
}))(MerchantDetail);